import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
    <footer className="border-t border-white/[0.07] bg-[#080809]" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                <div>
                    <div className="flex items-center gap-3 mb-4">
                        <img src="/assets/ana-emblem.png" alt="ANA International emblem" className="h-11 w-11 object-contain" />
                        <div className="leading-tight">
                            <span className="font-display font-bold tracking-[0.18em] text-sm block">ANA</span>
                            <span className="text-[10px] tracking-[0.32em] text-[#a3a29b] uppercase">International</span>
                        </div>
                    </div>
                    <p className="text-sm text-[#a3a29b] leading-relaxed">
                        ANA INTERNATIONAL PRIVATE LIMITED
                    </p>
                    <p className="text-sm text-[#e8c766] mt-2 font-display">
                        “Building the Future of Digital Products.”
                    </p>
                </div>

                <div>
                    <p className="mono-label mb-5">Pages</p>
                    <ul className="space-y-3 text-sm text-[#c9c8c2]">
                        {[
                            ["Home", "/"],
                            ["About", "/about"],
                            ["Products", "/products"],
                            ["Lyanka AI", "/lyanka-ai"],
                            ["Vision", "/vision"],
                            ["Contact", "/contact"],
                        ].map(([label, to]) => (
                            <li key={to}>
                                <Link to={to} className="hover:text-[#e8c766] transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="mono-label mb-5">Legal</p>
                    <ul className="space-y-3 text-sm text-[#c9c8c2]">
                        <li><Link to="/privacy-policy" className="hover:text-[#e8c766] transition-colors" data-testid="footer-link-privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/terms-of-service" className="hover:text-[#e8c766] transition-colors" data-testid="footer-link-terms-of-service">Terms of Service</Link></li>
                        <li><Link to="/refund-policy" className="hover:text-[#e8c766] transition-colors" data-testid="footer-link-refund-policy">Refund Policy</Link></li>
                        <li><Link to="/cookie-policy" className="hover:text-[#e8c766] transition-colors" data-testid="footer-link-cookie-policy">Cookie Policy</Link></li>
                    </ul>
                </div>

                <div>
                    <p className="mono-label mb-5">Contact</p>
                    <ul className="space-y-3 text-sm text-[#c9c8c2]">
                        <li className="flex items-start gap-2.5">
                            <Mail size={15} className="mt-0.5 text-[#c9a227] shrink-0" />
                            <a href="mailto:info@anainternationalpvt.com" className="hover:text-[#e8c766] transition-colors" data-testid="footer-email-link">
                                info@anainternationalpvt.com
                            </a>
                        </li>
                        <li className="flex items-start gap-2.5">
                            <Phone size={15} className="mt-0.5 text-[#c9a227] shrink-0" />
                            <a href="tel:+918799843634" className="hover:text-[#e8c766] transition-colors" data-testid="footer-phone-link">
                                +91 87998 43634
                            </a>
                        </li>
                        <li className="flex items-start gap-2.5">
                            <MapPin size={15} className="mt-0.5 text-[#c9a227] shrink-0" />
                            <span>Registered Office: Ahmednagar, Maharashtra, India</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-14 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                <p className="text-xs text-[#7c7b75]">© 2026 ANA INTERNATIONAL PRIVATE LIMITED. All Rights Reserved.</p>
                <p className="text-xs text-[#7c7b75] font-mono tracking-wider">CIN: U46301PN2025PTC248911</p>
            </div>
        </div>
    </footer>
);
